export type FreeRequestStatus = 'new' | 'approved' | 'rejected';

export interface FreeRequest {
	uuid: string;
	user_uuid: string;
	status: FreeRequestStatus;
	created: string;
	resolved: string | null;
	resolved_by_uuid: string | null;
	comment: string | null;
}

export interface FreeRequests {
	items: FreeRequest[];
	total: number;
}

export const STATUS_LABELS: Record<FreeRequestStatus, string> = {
	new: 'Новая',
	approved: 'Одобрена',
	rejected: 'Отклонена',
};

export const STATUS_BADGES: Record<FreeRequestStatus, string> = {
	new: 'badge-light-primary',
	approved: 'badge-light-success',
	rejected: 'badge-light-danger',
};
